import { defineComponent, ref } from "vue";
import { emojiBaseUrl, emojiMap, emojiList } from "../util.mjs";
import { isMobile } from "../../../utils/environment.mjs";
import SvgIcon from "../../common/base/SvgIcon.vue.mjs";
import EmojiIcon from "../../common/icons/EmojiIcon.vue.mjs";
import "../../../directives/vClickOutside.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "emojiPC",
  emits: ["choose-emoji"],
  setup(__props, { emit }) {
    const showEmojiToolbar = ref(false);
    const chooseEmoji = (itemName) => {
      const emojiInfo = itemName;
      emit("choose-emoji", emojiInfo);
    };
    const handleEmojiToobar = () => {
      showEmojiToolbar.value = !showEmojiToolbar.value;
    };
    const handleClickOutsideEmojiToobar = () => {
      if (showEmojiToolbar.value) {
        showEmojiToolbar.value = false;
      }
    };
    return { __sfc: true, emit, showEmojiToolbar, chooseEmoji, handleEmojiToobar, handleClickOutsideEmojiToobar, emojiBaseUrl, emojiMap, emojiList, isMobile, SvgIcon, EmojiIcon };
  }
});
export {
  _sfc_main as default
};
